if (!customElements.get('bundle-builder')) {
  class BundleBuilder extends HTMLElement {
    connectedCallback() {
      const configEl = this.querySelector('[data-bundle-config]');
      if (!configEl) return;
      this.config = JSON.parse(configEl.textContent);
      this.state = { buy: null, get: null };
      this.originalWrap = this.querySelector('[data-original]');
      this.originalPrice = this.originalWrap ? this.originalWrap.querySelector('s') : null;
      this.finalPrice = this.querySelector('[data-final]');
      this.hintEl = this.querySelector('[data-hint]');
      this.button = this.querySelector('[data-add-button]');
      this.errorEl = this.querySelector('[data-error]');
      this.formatter = new Intl.NumberFormat('he-IL', {
        style: 'currency',
        currency: this.config.currency || 'ILS',
        minimumFractionDigits: 0,
        maximumFractionDigits: 2,
      });
      this.options = Array.from(this.querySelectorAll('[data-bundle-option]'));
      this.options.forEach((opt) => {
        const selectBtn = opt.querySelector('.bundle-option__select');
        if (selectBtn && !opt.hasAttribute('data-fixed') && !selectBtn.disabled) {
          selectBtn.addEventListener('click', () => this.selectOption(opt));
        }
        opt.querySelectorAll('.bundle-size').forEach((sizeBtn) => {
          sizeBtn.addEventListener('click', () => this.selectSize(opt, sizeBtn));
        });
        if (opt.hasAttribute('data-fixed')) this.selectOption(opt);
      });
      if (this.button) this.button.addEventListener('click', () => this.addToCart());
      this.update();
    }

    selectOption(opt) {
      const group = opt.dataset.group;
      this.options
        .filter((o) => o.dataset.group === group)
        .forEach((o) => {
          const selected = o === opt;
          o.classList.toggle('is-selected', selected);
          const btn = o.querySelector('.bundle-option__select');
          if (btn) btn.setAttribute('aria-pressed', selected ? 'true' : 'false');
          const sizes = o.querySelector('.bundle-option__sizes');
          if (sizes) sizes.hidden = !selected;
          if (!selected) {
            o.querySelectorAll('.bundle-size.is-selected').forEach((b) => b.classList.remove('is-selected'));
          }
        });
      const single = opt.querySelector('[data-single-variant]');
      const chosenSize = opt.querySelector('.bundle-size.is-selected');
      this.state[group] = {
        productId: Number(opt.dataset.productId),
        variantId: single ? Number(single.value) : chosenSize ? Number(chosenSize.dataset.variantId) : null,
        priceCents: single
          ? Number(single.dataset.price)
          : chosenSize
            ? Number(chosenSize.dataset.price)
            : Number(opt.dataset.price),
      };
      if (this.errorEl) this.errorEl.hidden = true;
      this.update();
    }

    selectSize(opt, sizeBtn) {
      if (!opt.classList.contains('is-selected')) this.selectOption(opt);
      opt.querySelectorAll('.bundle-size').forEach((b) => b.classList.remove('is-selected'));
      sizeBtn.classList.add('is-selected');
      const group = opt.dataset.group;
      if (!this.state[group] || this.state[group].productId !== Number(opt.dataset.productId)) {
        this.selectOption(opt);
        opt.querySelectorAll('.bundle-size').forEach((b) => b.classList.remove('is-selected'));
        sizeBtn.classList.add('is-selected');
      }
      this.state[group].variantId = Number(sizeBtn.dataset.variantId);
      this.state[group].priceCents = Number(sizeBtn.dataset.price);
      if (this.errorEl) this.errorEl.hidden = true;
      this.update();
    }

    update() {
      const { buy, get } = this.state;
      const originalCents = (buy ? buy.priceCents : 0) + (get ? get.priceCents : 0);
      const productsChosen = !!(buy && get);
      const complete = !!(buy && buy.variantId && get && get.variantId);
      if (productsChosen) {
        const finalCents = Math.max(originalCents - this.config.discountCents, 0);
        if (this.originalWrap && this.originalPrice) {
          this.originalPrice.textContent = this.formatter.format(originalCents / 100);
          this.originalWrap.hidden = finalCents >= originalCents;
        }
        if (this.finalPrice) this.finalPrice.textContent = this.formatter.format(finalCents / 100);
      } else {
        if (this.originalWrap) this.originalWrap.hidden = true;
        if (this.finalPrice) {
          this.finalPrice.textContent = originalCents > 0 ? this.formatter.format(originalCents / 100) : '';
        }
      }
      if (this.button) this.button.disabled = !complete;
      if (this.hintEl) {
        let hint = '';
        if (!complete) {
          if (!buy && !get) hint = this.dataset.hintBoth || '';
          else if (!buy) hint = this.dataset.hintBuy || '';
          else if (!get) hint = this.dataset.hintGet || '';
          else hint = this.dataset.hintSize || '';
        }
        this.hintEl.textContent = hint;
      }
    }

    async addToCart() {
      const { buy, get } = this.state;
      if (!(buy && buy.variantId && get && get.variantId)) return;
      if (this.errorEl) this.errorEl.hidden = true;
      this.button.disabled = true;
      this.button.classList.add('loading');
      try {
        const response = await fetch(this.config.cartAddUrl, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({
            items: [
              { id: buy.variantId, quantity: 1 },
              { id: get.variantId, quantity: 1 },
            ],
            sections: 'cart-drawer,cart-icon-bubble',
            sections_url: window.location.pathname,
          }),
        });
        const data = await response.json();
        if (!response.ok || data.status) {
          throw new Error(data.description || 'Bundle add to cart failed');
        }
        const drawer = document.querySelector('cart-drawer');
        if (
          drawer &&
          typeof drawer.renderContents === 'function' &&
          data.sections &&
          data.sections['cart-drawer']
        ) {
          // Dawn keeps an is-empty class on the <cart-drawer> element itself when the
          // page loaded with an empty cart; product-form.js removes it before rendering,
          // so we must do the same or the line items stay hidden.
          drawer.classList.remove('is-empty');
          const emptyInner = drawer.querySelector('.drawer__inner.is-empty');
          if (emptyInner) emptyInner.classList.remove('is-empty');
          drawer.renderContents(data);
        } else {
          window.location.href = this.config.cartUrl;
        }
      } catch (error) {
        console.error('[bundle-builder]', error);
        if (this.errorEl) this.errorEl.hidden = false;
      } finally {
        this.button.classList.remove('loading');
        this.update();
      }
    }
  }
  customElements.define('bundle-builder', BundleBuilder);
}
